export const getInfoErrorTO = errorTargetedOffers => {
  const isErrService = typeof errorTargetedOffers?.code === 'string'
    ? errorTargetedOffers?.code.startsWith('ERR_')
    : false;
  const isNetWork = !!errorTargetedOffers?.isNetWorkError;
  return {
    isErrService,
    isNetWork,
    hasError: isErrService || isNetWork,
  };
};
